import React from "react";
import Card from "carbon-react/lib/components/card";
import CardRow from "carbon-react/lib/components/card/card-row";
import CardColumn from "carbon-react/lib/components/card/card-column";
import CardFooter from "carbon-react/lib/components/card/card-footer";
import Heading from "carbon-react/lib/components/heading";
import Link from "carbon-react/lib/components/link";
import { useUserApi } from "../../../../services/UserApi";
import { useAppContext } from "../../../../contexts/AppContext";

const RefreshTokenCard = ({
  user,
  refreshToken,
  onDeviceCredentialDeleted,
  openCommentsDialog,
  busy,
  onError,
}) => {
  const { agentEntitlement } = useAppContext();
  const { deleteDeviceCredential } = useUserApi();

  const isValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const deleteRefreshToken = async (params) => {
    try {
      var result = await deleteDeviceCredential(
        user?.userId,
        refreshToken?.id,
        params?.languageCode,
        params?.agentComments
      );

      if (!result.success)
        throw new Error(
          result.error?.description || "Failed to delete device credential"
        );

      if (isValidFunc(onDeviceCredentialDeleted)) {
        onDeviceCredentialDeleted();
      }
    } catch (error) {
      if (isValidFunc(onError)) {
        onError(error);
      }

      console.log("Failed to delete device credential...");
      console.log(error);
    }
  };

  const deleteRefreshTokenDialogState = {
    title: `Delete Refresh Token`,
    captureLanguage: true,
    userHeading: `${user?.name} (${user?.email}) - ${refreshToken?.deviceName}`,
    subTitle:
      "Deleting this Refresh Token will remove it from the users account. Are you sure you wish to continue?",
    promptCaption: "Confirm",
    prompts: [
      "Before proceeding, please ensure that you have positively verified that the person requesting this action is the owner of the account.",
    ],
    buttonCaption: "Delete",
    performAction: deleteRefreshToken,
    successToast: `Refresh Token deleted for '${user?.email}'.`,
  };

  const onDeleteRefreshToken = () => {
    if (busy) return;

    if (isValidFunc(openCommentsDialog)) {
      openCommentsDialog(deleteRefreshTokenDialogState);
    }
  };

  if (!user) return null;
  if (!refreshToken) return null;
  return (
    <div key={refreshToken.id}>
      <Card key={refreshToken.id}>
        <CardRow>
          <CardColumn>
            <Heading title={refreshToken?.deviceName} divider={false} />
          </CardColumn>
        </CardRow>
        <CardRow>
          <CardColumn>
            <strong>Id:</strong> {refreshToken?.id}
          </CardColumn>
        </CardRow>
        <CardRow>
          <CardColumn>
            <strong>Type:</strong> {refreshToken?.type}
          </CardColumn>
        </CardRow>
        <CardRow>
          <CardColumn>
            <strong>User Id:</strong> {refreshToken?.userId}
          </CardColumn>
        </CardRow>
        <CardRow>
          <CardColumn>
            <strong>Client Id:</strong> {refreshToken?.clientId}
          </CardColumn>
        </CardRow>
        <CardFooter>
          {agentEntitlement && agentEntitlement.users.canDeleteRefreshTokens && (
            <CardColumn align="center">
              <Link
                disabled={busy}
                onClick={() => {
                  onDeleteRefreshToken();
                }}
                icon="bin"
                iconAlign="left"
                tabbable
              >
                Delete
              </Link>
            </CardColumn>
          )}
        </CardFooter>
      </Card>
    </div>
  );
};

export default RefreshTokenCard;
